<iframe [src]="this.url | safe:'resourceUrl'" class="ap-news-iframe" frameborder="0" allowTransparency="true" allow></iframe>
